import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {Subject} from 'rxjs/Subject';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class DeliveryService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true);
  }


  /**
   * Get a list of delivery
   *
   * @returns {Observable<any>}
   */
  cget(cmdId) {
    const param = {'_format': 'json'};
    param['cart'] = cmdId;

    const url = this.Routing.generate('api_get_checkout_livraison', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(true); // enable custom loader
        return response.json().data;
      });

  }

  updateDeliveryCommande(delivery) {
    const param = {'_format': 'json'};
    param['commande'] = delivery.commande;

    const url = this.Routing.generate('api_patch_commande_livraison', param, true);

    return this.http
      .patch(url, JSON.stringify({
          modeLivraison: delivery.modeLivraison,
          remarquePublic: delivery.remarquePublic
        }
      ), {headers: this.updateHeaders()})
      .map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/delivery.service.ts